<template>
  <div class="view pa24">
    <div>
      {{ $t('business', 'memberName') }}：
      <el-select class="mr20" v-model="userId" clearable>
        <el-option
          v-for="(item, index) in staffs"
          :key="index"
          :label="item.name"
          :value="item.userId"
        >
          {{ item.name }}
        </el-option>
      </el-select>
      {{ $t('article', 'source') }}：
      <el-select class="mr20" v-model="sourcesId" clearable>
        <el-option
          v-for="item in sources"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
          {{ item.name }}
        </el-option>
      </el-select>
      {{ $t('article', 'isAuthorized') }}：
      <el-select class="mr20 mt10" v-model="authsId" clearable>
        <el-option
          v-for="item in auths"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
          {{ item.name }}
        </el-option>
      </el-select>
      {{ $t('article', 'browseTime') }}：
      <el-date-picker
        v-model="pickerValue"
        class="mr10 mt10"
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        :start-placeholder="$t('marketing', 'startDate')"
        :end-placeholder="$t('marketing', 'endDate')"
      />
    </div>
    <div>
      {{ $t('article', 'userPhone') }}：
      <el-input
        v-model="phone"
        class="w220 mt10 mr10"
        :placeholder="$t('article', 'enterPhoneNumber')"
      />
      <el-button type="primary" @click="queryVisitorsData">{{ $t('marketing', 'search') }}</el-button>
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column align="center" type="index"> </el-table-column>
        <el-table-column
          prop="nickeName"
          align="center"
          :label="$t('customer', 'wechat')"
          show-overflow-tooltip
        />
        <el-table-column prop="name" align="center" :label="$t('article', 'salesperson')" />
        <el-table-column prop="source" align="center" :label="$t('article', 'source')" />
        <el-table-column prop="phone" align="center" :label="$t('customer', 'phone')">
          <template slot-scope="scope">
            {{ scope.row.phone ? scope.row.phone : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="visitTime" align="center" :label="$t('article', 'recentBrowseTime')">
          <template slot-scope="scope">
            {{ scope.row.visitTime | getDataTimeSec }}
          </template>
        </el-table-column>
        <el-table-column prop="sumNum" align="center" :label="$t('article', 'totalCount')" />
        <el-table-column prop="sumTimes" align="center" :label="$t('article', 'totalTime')" />
        <el-table-column prop="forwardfNum" align="center" :label="$t('article', 'forwardCount')" />
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import { queryCompanyStaff, queryVisitorsData } from "@/api/articleManagement";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      sources: [
        { id: 0, name: this.$t('article', 'all') },
        { id: 3, name: this.$t('article', 'article') },
        { id: 2, name: this.$t('article', 'businessCard') },
        { id: 1, name: this.$t('article', 'poster') },
      ],
      sourcesId: "",
      auths: [
        { id: 3, name: this.$t('article', 'all') },
        { id: 1, name: this.$t('article', 'authorizedPhone') },
        { id: 0, name: this.$t('article', 'unauthorizedPhone') },
      ],
      authsId: "",
      phone: "",
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryCompanyStaff();
    this.queryVisitorsData();
  },
  methods: {
    async queryCompanyStaff() {
      try {
        const result = await queryCompanyStaff({ companyId: 0 });
        this.staffs = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    async queryVisitorsData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        authPhone: this.authsId,
        userId: this.userId,
        source: this.sourcesId,
        phone: this.phone,
        visitTimeStart: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        visitTimeEnd: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      try {
        this.loading = true;
        const result = await queryVisitorsData(data);
        this.loading = false;
        const { total, list } = result?.data;
        this.tableData = list;
        this.tableData.forEach(item=>{
          item.salesman = true;
                  //1海报 2名片 3 文章
        item.source = item.source == 3 ? this.$t('article', 'article') :  item.source == 2 ? this.$t('article', 'businessCard') :  item.source == 1 ? this.$t('article', 'poster'):"";
          item.sumTimes = this.formatSeconds(item.sumTimes);
        })
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+this.$t('article', 'second');
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+this.$t('article', 'minute')+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+this.$t('article', 'hour')+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVisitorsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVisitorsData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>